import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const SavingsBankAccount = () => {
  return (
    <>
      <TopBanner content={"Savings Bank Account"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Savings Account Your Everyday Banking Partner</h2>
          <p>
            A Savings Account is the most essential and widely used banking
            service in India. It helps you securely store your extra money while
            earning interest and offers the convenience of daily banking.
          </p>

          <h3>Why Choose a Savings Account?</h3>
          <ul>
            <li>Keep Your Money Safe & Accessible</li>
            <li>Earn Interest (Typically 3% to 4%)</li>
            <li>Free Debit Card & Net Banking Facility</li>
            <li>Locker & Emergency Fund Options</li>
            <li>Zero Risk with Full Liquidity</li>
          </ul>

          <h3>How to Open a Savings Account?</h3>
          <p>
            You can open a savings account at any bank or post office, either
            online or by visiting your nearest branch. Once your account is
            active, you’ll receive a passbook, debit card, and access to
            mobile/net banking.
          </p>

          <h3>Types of Savings Accounts:</h3>
          <ul>
            <li>Regular Savings Account</li>
            <li>Salary Account</li>
            <li>Senior Citizen Savings Account</li>
            <li>Joint Account</li>
            <li>Zero Balance Account</li>
          </ul>

          <p>
            Whether it’s for daily expenses, emergency savings, or secure
            digital banking a Savings Account keeps your money ready, anytime
            you need it.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default SavingsBankAccount;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
